// extracted by mini-css-extract-plugin
export default {"book":"_2QrbUtkq","bookTitle":"MhWWPVfz","bookFooter":"gbfhV_d8"};